import { Grid, InputAdornment } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { isEmpty, isNotNull } from '../../common/util.services';
import { getEnquiryById, saveEnquiry } from '../enquiry.services';
import './enquiry-form.component.scss';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import { ENQ_CONV_STATUS_ITEMS, GET_ALL_CUSTOMER_URL} from '../../common/constants';
import LinkIcon from '@mui/icons-material/Link';
import EnquiryProduct from '../enq-product/product.component';
import { GridRowsProp, useGridApiRef } from '@mui/x-data-grid';
import { Visibility } from '@mui/icons-material';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';

const EnquiryForm = (props: any) => {
  const [title, setTitle] = useState<string>('Add Enquiry');
  const appContext = useContext(AppContext);
  const apiRef = useGridApiRef();
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const params = useParams()
  const rowId = params.rowId;
  const [enquiryData, setEnquiryData] = useState<any>({customer:[], conversionStatus: 'Open', enquiryDate: dayjs()});
  const [enqProduct, setEnqProduct] = useState(rows);
  const [loader, setLoader] = useState(true);
  const [details, setDetails] = useState('');
  const detailsLink = "https://drive.google.com/drive/folders/1BQ4KmsLFSiJ0FaPFnfuXqQCqOcqyo01S";

  useEffect(() => {
    if (isNotNull(rowId)) {
      getEnquiryById(rowId, appContext,
        (response: any) => {
          setDetails(response.data.detailsLink);
          setTitle('Edit Enquiry');
          setEnquiryData(response.data);
          response.data.enquiryDate = dayjs(response.data.enquiryDate);
          setEnqProduct(response.data.product);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);

  const validProduct = () => {
    let valid = true;

    if(enqProduct.length <= 0) {
      appContext.setDialogMessage('Add product details.');
      return false;
    }
    
    enqProduct.forEach(row => {
      if (isEmpty(row.quantity) || isEmpty(row.costingOwner) || isEmpty(row.description) || 
          (0 === row.pack && !row.product.includes('Fabric'))) {
        valid = false;
        appContext.setDialogMessage('Specify Pc/Pack, Quantity, Description, and Costing Owner.');
      }
    })

    return valid;
  }

  const onSubmit = (data: any) => {
    let today = dayjs(dayjs().format('YYYY-MM-DD'));
    let enqDate = dayjs(dayjs(data.enquiryDate).format('YYYY-MM-DD'));
    let cosDate = dayjs(dayjs(data.costingDate).format('YYYY-MM-DD'));
    if(enqDate.isAfter(today)) {
      appContext.setDialogMessage('Future enquiry date is not allowed.');
      return;
    } else if(enqDate.isAfter(cosDate)) {
      appContext.setDialogMessage('Enquiry date is after a costing date.');
      return;
    }

    if (validProduct()) {
      data.product = enqProduct;
      saveEnquiry(data, appContext,
        (response: any) => {
          navigate('/enquiry/list');
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
    }
  }

  const onRowSelection = (selectedRows: any) => {
    setEnqProduct(selectedRows);
  }

  const onRowDelete = (selectedRows: any) => {
    setEnqProduct(selectedRows);
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={3}>
        <ITextField name='code' label='Enquiry Code' required={false} disabled={true}/>
      </Grid>
      <Grid xs={3}>
        <IDropdown name='customer' label='Customer' required={true} url={GET_ALL_CUSTOMER_URL} disabled={isNotNull(rowId)}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='detailsLink' label='Details Link' required={true} 
         InputProps={{startAdornment: (<InputAdornment position="start"> <Link to={detailsLink} target="_blank"> <LinkIcon/> </Link> </InputAdornment>),
                      endAdornment: (<InputAdornment position="end"> <Link to={details} target="_blank"> <Visibility/> </Link> </InputAdornment>)}}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='referrence' label='Buyer Quote/Referrence' required={false}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='remarks' label='Remarks' required={false}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='referrer' label='Referrer' />
      </Grid>
      <Grid xs={3}>
        <IDateField name='enquiryDate' label='Enquiry Date'/>
      </Grid>
      <Grid xs={3}>
        <IDropdown name='conversionStatus' label='Conv Status' itemList={ENQ_CONV_STATUS_ITEMS}/>
      </Grid>
      <Grid xs={12}>
        <EnquiryProduct onRowSelection={onRowSelection} onRowDelete={onRowDelete} 
         enqProduct={enquiryData.product} apiRef={apiRef}/>
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={enquiryData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default EnquiryForm;